import React from 'react';
import PropTypes from "prop-types";
import "./dropdown.css";

export class DropdownComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listClass: ""
        };
        this.handleTitleClick = this.handleTitleClick.bind(this);
    }

    handleTitleClick(e) {
        if(this.state.listClass !== "visible" && this.state.listClass !== "transition") {
            let state = Object.assign(this.state);
            state.listClass = "transition";
            this.setState(state);
            setTimeout(() => {
                state = Object.assign(this.state);
                state.listClass = "visible";
                this.setState(state);
            }, 100);
        } else {
            let state = Object.assign(this.state);
            state.listClass = "";
            this.setState(state);
        }
    }

    render() {
        return (
            <div className={"dropdown " + this.props.className}>
                <div className="dropdown-title">
                    <a onClick={this.handleTitleClick}>
                        {this.props.title}
                    </a>
                </div>
                <ul className={"dropdown-menu " + this.state.listClass} aria-label={this.props.description}>
                    <div className="dropdown-content">
                        {this.props.content}
                    </div>
                </ul>
            </div>
        );
    }
}

DropdownComponent.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    description: PropTypes.string,
    content: PropTypes.node.isRequired,
};

export class DropdownLinksComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: props.links.map((link, index) => {
                return (<li key={link.key}><a href={link.link}>{link.value}</a></li>);
            })
        };
    }
    render(){
        return(
            <DropdownComponent title={this.props.title} description={this.props.description} content={this.state.content}/>
        )
    }
}
DropdownLinksComponent.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired,
    description: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        link: PropTypes.string,
        key: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired
    })).isRequired
};



// WEBPACK FOOTER //
// ./src/dropdown/Dropdown.js